module.exports = __webpack_public_path__ + "img/home-1Icon@2x.afcc3ecb.svg";